var map = {
	"./ReactCerti.png": 455,
	"./ScrumCerti.png": 775,
	"./aws-cloud-foundations.png": 760,
	"./aws-machine-learning-foundations.png": 323,
	"./certSpringBoot.png": 625,
	"./cert_java_docker.jpg": 588,
	"./dockerCerti.png": 922,
	"./javaCertificado.jpg": 220,
	"./reactNativeCerti.png": 191,
	"./sqlCerti.png": 469,
	"./unesplogo.png": 176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 995;